module.exports = __webpack_public_path__ + "img/quote.2454e62a.jpg";